import {
  LOGIN_PATH,
  DASHBOARD_PATH,
  LOCK_SCREEN_PATH,
  TOKEN_COOKIE_NAME,
  PASSWORD_RESET_PATH,
  ACCOUNT_SIGNUP_PATH,
} from 'constants/general';
import { appTheme } from 'theme';
import { history } from 'store/store';
import { manageCookie } from 'utils/';
import { useChatWidget } from 'hooks/';
import { useSelector } from 'react-redux';
import { Loader } from 'components/Loaders/';
import SignIn from 'containers/SignIn/SignIn';
import SignUp from 'containers/SignUp/SignUp';
import { ModalProvider } from 'contexts/Modal';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from 'theme/globalStyles';
import React, { Suspense, useEffect } from 'react';
import Container from 'containers/Container/Container';
import LockScreen from 'containers/LockScreen/LockScreen';
import RootModal from 'containers/Modals/RootModal/RootModal';
import { Route, Switch, Router, useLocation } from 'react-router-dom';

function App() {
  const unGuardedRoutes = [
    LOCK_SCREEN_PATH,
    ACCOUNT_SIGNUP_PATH,
    PASSWORD_RESET_PATH,
  ];
  const routerLocation = useLocation();
  const { pathname } = routerLocation;
  const accessToken = manageCookie({ name: TOKEN_COOKIE_NAME });
  const isLoggedOut = useSelector(({ isLoggedOut }) => isLoggedOut);
  const signUpRoute = pathname === ACCOUNT_SIGNUP_PATH;
  const lockScreenRoute = pathname === LOCK_SCREEN_PATH;
  const unAuthenticated = !accessToken || isLoggedOut;
  const passwordResetRoute = pathname === PASSWORD_RESET_PATH;
  useChatWidget(!unAuthenticated && !unGuardedRoutes.includes(pathname));

  useEffect(() => {
    const shouldClearToken =
      unAuthenticated && !unGuardedRoutes.includes(pathname);
    if (shouldClearToken) {
      manageCookie({ name: TOKEN_COOKIE_NAME, clear: true });
    }
  }, [pathname, unAuthenticated, unGuardedRoutes]);

  useEffect(() => {
    if (accessToken) {
      if (['/'].includes(pathname)) {
        history.push(DASHBOARD_PATH);
      }
    }
  }, [pathname, accessToken]);

  return (
    <Router history={history}>
      <ThemeProvider theme={appTheme}>
        <ModalProvider>
          <GlobalStyles />
          <RootModal />
          <Suspense fallback={<Loader />}>
            <Switch>
              <RenderElements />
            </Switch>
          </Suspense>
        </ModalProvider>
      </ThemeProvider>
    </Router>
  );

  function RenderElements() {
    if (signUpRoute) {
      return (
        <Route
          exact={true}
          name="signup"
          path={ACCOUNT_SIGNUP_PATH}
          render={(props) => <SignUp {...props} />}
        />
      );
    }
    if (lockScreenRoute) {
      return (
        <Route
          name="lock"
          exact={true}
          path={LOCK_SCREEN_PATH}
          render={(props) => <LockScreen {...props} />}
        />
      );
    }
    if (passwordResetRoute) {
      return (
        <Route
          exact={true}
          name="password-reset"
          path={PASSWORD_RESET_PATH}
          render={(props) => <SignIn {...props} target="password-reset" />}
        />
      );
    }
    if (unAuthenticated) {
      return (
        <Route
          name="login"
          exact={true}
          path={LOGIN_PATH}
          render={(props) => <SignIn {...props} target="sign-in" />}
        />
      );
    }
    return (
      <>
        <Container />
        <button id="zammad-feedback-form">Need help?</button>
        {/* <button className="open-zammad-chat">Chat with us</button> */}
      </>
    );
  }
}

export default App;
